var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5021_55616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8064 15.584C48.2097 18.1367 49.5001 20.9997 49.5001 25.6407C49.5001 33.8073 43.7671 41.127 35.4301 44.746L33.3464 41.5307C41.1281 37.3213 42.6494 31.859 43.2561 28.415C42.0031 29.0637 40.3627 29.29 38.7551 29.1407C34.5457 28.751 31.2277 25.2953 31.2277 20.9997C31.2277 18.8337 32.0881 16.7565 33.6197 15.225C35.1512 13.6934 37.2285 12.833 39.3944 12.833C41.8981 12.833 44.2921 13.9763 45.8064 15.584ZM22.4731 15.584C24.8764 18.1367 26.1667 20.9997 26.1667 25.6407C26.1667 33.8073 20.4337 41.127 12.0967 44.746L10.0131 41.5307C17.7947 37.3213 19.3161 31.859 19.9227 28.415C18.6697 29.0637 17.0294 29.29 15.4217 29.1407C11.2124 28.751 7.89673 25.2953 7.89673 20.9997C7.89673 18.8337 8.75714 16.7565 10.2887 15.225C11.8202 13.6934 13.8975 12.833 16.0634 12.833C18.5671 12.833 20.9611 13.9763 22.4754 15.584H22.4731Z",
    fill: "#EDA15C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5021_55616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.299cd7c7e6cbbba56cae158f0c6d4a0d.svg";
export { ForwardRef as ReactComponent };